import { useArchiveCustom } from "@/api/customs.api";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { Custom } from "@/types/api/api-types";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

type CustomArchiveModalProps = {
  open: boolean;
  onClose: () => void;
  custom: Custom;
};

export const CustomArchiveModal = ({ open, onClose, custom }: CustomArchiveModalProps) => {
  const { t } = useTranslation(["boCustoms", "common"]);
  const { mutateAsync: archiveCustom, isPending } = useArchiveCustom();

  const handleConfirm = async () => {
    await archiveCustom({
      id: custom.id,
      payload: { isArchived: !custom.isArchived },
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      title={custom.isArchived ? t("archiveModal.unarchiveTitle") : t("archiveModal.archiveTitle")}
      description={t("archiveModal.description")}
      footer={
        <div className="flex w-full gap-2">
          <Button
            type="button"
            variant="outline"
            className="flex-1"
            disabled={isPending}
            onClick={onClose}
          >
            {t("common:actions.cancel")}
          </Button>
          <Button type="button" className="flex-1" disabled={isPending} onClick={handleConfirm}>
            {isPending ? (
              <Loader2 className="mx-auto size-4 animate-spin" />
            ) : (
              t("archiveModal.submit")
            )}
          </Button>
        </div>
      }
    />
  );
};
